import { createSlice } from '@reduxjs/toolkit';

import { addStateFetch } from '@webapp/account/src/resources/store-utils';

import { addSurveyTranslation, deleteSurveyTranslation, getAllLanguages, getSurveyLanguages } from './async';
import { initialState } from './state';

export const multiLangeSlice = createSlice({
    name: 'survey',
    initialState,
    reducers: {},
    extraReducers: (builder) =>
        addStateFetch(
            builder
                .addCase(getAllLanguages.fulfilled, (s, action) => {
                    s.allLanguages = action.payload.data || [];
                    s.allLanguages.sort((a, b) => a.nameRu.localeCompare(b.nameRu));

                    s.isAllLanguagesLoaded = true;
                })
                .addCase(getSurveyLanguages.fulfilled, (s, action) => {
                    s.surveyLanguages = action.payload.data || [];
                })
                .addCase(addSurveyTranslation.fulfilled, (s, action) => {
                    action.meta.arg.langs?.forEach((item: string) => {
                        const findLang = s.allLanguages.find((allLangItem) => allLangItem.code === item);
                        s.surveyLanguages.push({ ...findLang, status: 'empty' });
                    });
                })
                .addCase(deleteSurveyTranslation.fulfilled, (s, action) => {
                    s.surveyLanguages = s.surveyLanguages.filter((item) => item.code !== action.meta.arg.lang);
                }),
        ),
});

const MultiLangReducer = multiLangeSlice.reducer;

export { MultiLangReducer };
